<div class="flgrow mt-3">
    <div class="row">
        <div class="col-12 mb15">
            <div class="flmid">
                <div class="flgrow">
                    <input class="form-control" type="text" name="searchTerm"
                        placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="pService.searchTerm"
                        autocomplete="off" />
                </div>
                <div class="form-check p-0 pl-5 flgrow">
                    <input type="checkbox" id="onlyAutoKey" [(ngModel)]="onlyAutoKey" class="form-check-input" />
                    <label class="form-check-label" for="order" translate>lblShowOnlyAutoKey</label>
                </div>
            
            <div
                class="mr-2">
                <button type="submit" (click)="onClickChangeView(false)"
                    [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
                    translate>lblSATodayView
                </button>
                <button (click)="onClickChangeView(true)"
                    [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class=""
                    translate>lblSAWeekView
                </button>
                <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                    (click)='refresh()'>
                    <em class="fas fa-sync fa-lg"></em>
                </a>
            </div>
        </div>
    </div>
</div>
<div class="table-responsive">
    <table class="tablest1">
        <thead>
            <tr>
                <th style="width: 20%" scope="col" sortable="Name" translate>lblSelect</th>
                <th style="width: 20%" scope="col" translate>lblRegNumber</th>
                <th style="width: 20%" scope="col" translate>lblWoNo</th>
                <th style="width: 20%" scope="col" translate>lblPaymentMode</th>
                <th style="width: 20%" scope="col" translate>lblIsAutoKey</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="workOrderDetails?.length>0; else load_else">
                <tr *ngFor="let workOrder of workOrderDetails; let i=index">
                    <td>
                        <input type="radio" name="keys_on_hand" [disabled]="workOrder.isAllocated"
                            [value]="workOrder.appointmentId" (change)="findObject(workOrder)">
                    </td>
                    <td>
                        <ngb-highlight [result]="workOrder.licensePlate" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight [result]="workOrder.workorderNo" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                        <label *ngIf="workOrder.isShareboxPaymentMethod; else NotShareboxPaymentMethod" translate>lblShareBoxPayment</label>
                        <ng-template #NotShareboxPaymentMethod>
                            <label translate>lblInvoice</label>
                        </ng-template>
                    </td>
                    <td>
                        <em class="fas fa-check fa-lg cursordisable"  *ngIf="workOrder.isAutoKey === true"></em>
                        <em class="fas fa-times text-danger fa-lg cursordisable"  *ngIf="workOrder.isAutoKey === false"></em>
                    </td>
                </tr>
            </ng-container>
            <ng-template #load_else>
                <tr>
                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</div>